"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemShare = void 0;
var ShareItemClickEvent = _interopRequireWildcard(require("@ori-events/share-item-click"));
var _analyticsData = require("@ori/analytics-data");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _components = require("./components");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DetailItemShare = ({
  itemId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const sharedUrl = (0, _react.useMemo)(() => `${window.location.href.split('#')[0]}#opi${itemId}`, [itemId]);
  const filteredSocialIcons = (0, _react.useMemo)(() => {
    if (_constants.vkMarkets.includes(tenant)) {
      return _constants2.allowedSocialPlatforms.filter(kind => kind !== 'facebook');
    }
    return _constants2.allowedSocialPlatforms.filter(kind => kind !== 'vkontakte');
  }, [tenant]);
  const onShare = (0, _react.useCallback)(method => () => {
    const customEvent = new CustomEvent(ShareItemClickEvent.Name, {
      detail: {
        method,
        contentType: _analyticsData.ContentType.Photo,
        placement: _analyticsData.Placement.OlapicWidget,
        itemCode: itemId
      }
    });
    window.dispatchEvent(customEvent);
  }, [itemId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants2.DETAIL_ITEM_SHARE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
      children: filteredSocialIcons.map(kind => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialShareIcon, {
        kind: kind,
        sharedUrl: sharedUrl,
        onClick: onShare(kind)
      }, kind))
    })
  });
};
exports.DetailItemShare = DetailItemShare;
